var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans text-primary antialiased bg-white overflow-x-hidden",attrs:{"id":"app"}},[_c('MainHeader'),_c('router-view'),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }